import { render, staticRenderFns } from "./VideoToolToy.vue?vue&type=template&id=07b87c7f&"
import script from "./VideoToolToy.vue?vue&type=script&lang=js&"
export * from "./VideoToolToy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports